<template>
	<div
		class="featured_tile"
		:style="{'--size': size}"
		:class="{'full-width': size === 'span 12', 'two-thirds': size === 'span 8', 'one-third': size === 'span 4'}"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
	>
		<div class="inner">
			<div class="content">
				<div
					class='description'
					v-html="description"
				></div>
			</div>
			<div
				class='cta_container'
				v-if="parsedCta"
			>
				<primary-button
					:link="parsedCta"
					:label="parsedCta.title"
					:is_hovered="hovered"
					theme="dark"
					@mouseenter.native="handleButtonMouseEnter"
					@mouseleave.native="handleButtonMouseLeave"
				></primary-button>
			</div>
		</div>
	</div>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
export default {
	data() {
		return {
			hovered: false,
		};
	},

	props: {
		description: {},
		call_to_action: {},
		size: {},
	},

	computed: {
		parsedCta() {
			if (this.call_to_action) {
				return JSON.parse(this.call_to_action);
			} else {
				return null;
			}
		},

		parsedIcon() {
			if (this.icon) {
				return JSON.parse(this.icon);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleButtonMouseEnter() {
			this.hovered = true; // Update parent's hovered state
		},
		handleButtonMouseLeave() {
			this.hovered = false; // Update parent's hovered state
		},
	},

	components: { PrimaryButton },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.featured_tile {
	display: grid;
	/* background: var(--very-light-grey); */
	grid-column: var(--size);
	/* border: 2px solid transparent; */
	transition: 0.2s ease all;

	aside & {
		margin-top: -20px;
		margin-left: -50px;
		/* position: sticky;
		top: 150px; */

		@media (max-width: $mobile-xl) {
			margin-top: unset;
			margin-left: unset;
		}
	}

	.inner {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		background: var(--background-colour);
		border-radius: 25px;
		padding: 100px 50px;
		max-width: calc(100% - 100px);
	}

	&.index__zero {
		padding: 50px 50px 50px 40px;

		@media (max-width: $mobile-xl) {
			padding: 24px;
		}
	}

	&.index__one {
		padding: 50px;

		@media (max-width: $mobile-xl) {
			padding: 24px;
		}
	}

	&.index__two {
		padding: 50px 40px 50px 50px;

		@media (max-width: $mobile-xl) {
			padding: 24px;
		}
	}

	&.two-thirds {
		grid-template-columns: 100px auto 100px;

		@media (max-width: $mobile-xl) {
			grid-template-columns: unset;
		}

		.inner {
			grid-column: 2 / span 1;

			@media (max-width: $laptop) {
				grid-column: unset;
			}
		}
	}

	.description {
		&::v-deep {
			p,
			div {
				color: white;
				font-size: 30px;
				line-height: 35px;

				&:first-of-type {
					margin-top: 0;
				}

				&:last-of-type {
					margin-bottom: 0;
				}
			}
		}
	}

	.cta_container {
		margin-top: 50px;

		@media (max-width: 1440px) {
			.site_button {
				min-width: auto;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeaturedTile.vue